import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../guards/authenticated.guard';
import { MapViewPageComponent } from './map-view.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: MapViewPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class MapViewPageRoutingModule {}
